var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.29 6.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#4A4A4A;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "content") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL_-_ICONS",
    "data-name": "ALL - ICONS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.42.35a.34.34,0,0,1,.34.34V2.42a.34.34,0,0,1-.34.34H.69a.34.34,0,0,1-.34-.34V.69A.34.34,0,0,1,.69.35H2.42m0-.35H.69A.69.69,0,0,0,0,.69V2.42a.69.69,0,0,0,.69.69H2.42a.69.69,0,0,0,.69-.69V.69A.69.69,0,0,0,2.42,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.8,
    y: 0.69,
    width: 4.49,
    height: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.8,
    y: 2.07,
    width: 4.49,
    height: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.42,4.14a.35.35,0,0,1,.34.35V6.21a.34.34,0,0,1-.34.35H.69a.34.34,0,0,1-.34-.35V4.49a.35.35,0,0,1,.34-.35H2.42m0-.34H.69A.69.69,0,0,0,0,4.49V6.21a.69.69,0,0,0,.69.7H2.42a.69.69,0,0,0,.69-.7V4.49a.69.69,0,0,0-.69-.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.8,
    y: 4.49,
    width: 4.49,
    height: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.8,
    y: 5.87,
    width: 4.49,
    height: 0.34
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.6b8de4f703948312d996dcc03bb08822.svg";
export { ForwardRef as ReactComponent };